import { FormControl } from '@chakra-ui/react'
import { useFormContext } from 'BrokerTsLib/src/rhf'

import { FormLabel, InputGroup } from '@/components'
import { FormRow } from '@/containers/forms/FormRow'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import type { WizardPropertyAdditionalData } from 'BrokerTsLib/src/dtos'

export const AdditionalPropertyInfoFloorAreas = () => {
  const { insuranceParams } = useInsuranceParams()

  const isContracted = !!insuranceParams?.generalParams.contractNumber
  const { register, formState: { errors }, getFieldState, setValue, getValues } = useFormContext<WizardPropertyAdditionalData>()

  const floorsCount = getValues('property.additionalDataFloorAreas.floorsCount')!
  const atticFloorAreaRequired = getValues('property.additionalDataFloorAreas.atticFloorAreaRequired')
  const cellarFloorAreaRequired = getValues('property.additionalDataFloorAreas.cellarFloorAreaRequired')

  return (
    <FormRow>
      {floorsCount > 0 &&
        <>
          <FormControl isRequired isInvalid={!!errors.property?.additionalDataFloorAreas?.groundFloorArea}>
            <FormLabel>Plocha přízemí</FormLabel>
            <InputGroup
              isDisabled={isContracted}
              id="groundFloorArea"
              //htmlSize={8}
              autoComplete="off"
              inputMode="decimal"
              errors={errors.property?.additionalDataFloorAreas?.groundFloorArea}
              {...register('property.additionalDataFloorAreas.groundFloorArea')}
            />
          </FormControl>

          {floorsCount > 1 &&
            <FormControl isRequired isInvalid={!!errors.property?.additionalDataFloorAreas?.firstFloorArea}>
              <FormLabel>Plocha 1. patra</FormLabel>
              <InputGroup
                isDisabled={isContracted}
                id="firstFloorArea"
                //htmlSize={8}
                autoComplete="off"
                inputMode="decimal"
                errors={errors.property?.additionalDataFloorAreas?.firstFloorArea}
                {...register('property.additionalDataFloorAreas.firstFloorArea')}
              />
            </FormControl>
          }

          {floorsCount > 2 &&
            <FormControl isRequired isInvalid={!!errors.property?.additionalDataFloorAreas?.secondFloorArea}>
              <FormLabel>Plocha 2. patra</FormLabel>
              <InputGroup
                isDisabled={isContracted}
                id="secondFloorArea"
                //htmlSize={8}
                autoComplete="off"
                inputMode="decimal"
                errors={errors.property?.additionalDataFloorAreas?.secondFloorArea}
                {...register('property.additionalDataFloorAreas.secondFloorArea')}
              />
            </FormControl>
          }
        </>
      }

      {(atticFloorAreaRequired || cellarFloorAreaRequired) &&
        <>
          {atticFloorAreaRequired &&
            <FormControl isRequired isInvalid={!!errors.property?.additionalDataFloorAreas?.atticFloorArea}>
              <FormLabel>Plocha podkroví</FormLabel>
              <InputGroup
                isDisabled={isContracted}
                id="atticFloorArea"
                //htmlSize={8}
                autoComplete="off"
                inputMode="decimal"
                errors={errors.property?.additionalDataFloorAreas?.atticFloorArea}
                {...register('property.additionalDataFloorAreas.atticFloorArea')}
              />
            </FormControl>
          }

          {cellarFloorAreaRequired &&
            <FormControl isRequired isInvalid={!!errors.property?.additionalDataFloorAreas?.cellarFloorArea}>
              <FormLabel>Plocha sklepa</FormLabel>
              <InputGroup
                isDisabled={isContracted}
                id="cellarFloorArea"
                //htmlSize={8}
                autoComplete="off"
                inputMode="decimal"
                errors={errors.property?.additionalDataFloorAreas?.cellarFloorArea}
                {...register('property.additionalDataFloorAreas.cellarFloorArea')}
              />
            </FormControl>
          }
        </>
      }

      <FormControl isReadOnly isInvalid={!!errors.property?.additionalDataFloorAreas?.totalFloorArea}>
        <FormLabel>Zadaná celková podlahová plocha</FormLabel>
        <InputGroup
          isDisabled={isContracted}
          id="totalFloorArea"
          //htmlSize={8}
          autoComplete="off"
          inputMode="decimal"
          errors={errors.property?.additionalDataFloorAreas?.totalFloorArea}
          {...register('property.additionalDataFloorAreas.totalFloorArea')}
        />
      </FormControl>

    </FormRow>
  )
}
